import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "ms-1 text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Tableau de l'influence des facteurs sur les services écosystémiques"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "fst-italic" }, "Plus un facteur contient de niveaux qui participent potentiellement au service écosystémique, plus il apparait foncé. Cliquez sur les données du graphique pour obtenir plus d'informations.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_apexchart, {
      type: "heatmap",
      options: $setup.chartOptions,
      series: $setup.chartOptions.series,
      onDataPointSelection: $setup.onDataPointSelection
    }, null, 8, ["options", "series", "onDataPointSelection"]),
    _hoisted_1
  ]))
}